import { create } from 'zustand';
import { api } from './auth';

export const useDevices = create((set, get) => ({
  devices: [],
  selected: null,
  loading: false,

  fetch: async () => {
    set({ loading: true });
    const { data } = await api.get('/devices/');
    set({ devices: data, loading: false });
  },

  select: (device) => set({ selected: device }),

  sendCommand: async (deviceId, endpoint, body = {}) => {
    const { data } = await api.post(`/cmd/${deviceId}/${endpoint}`, body);
    return data;
  },

  bulkCommand: async (endpoint, body) => {
    const { data } = await api.post(`/cmd/bulk/${endpoint}`, body);
    return data;
  },

  setLabel: async (deviceId, label, group_name) => {
    await api.patch(`/devices/${deviceId}/label`, { label, group_name });
    get().fetch();
  },

  // Regular admin: soft-delete (hides from own dashboard, stays visible to super admin)
  softDelete: async (deviceId) => {
    await api.delete(`/devices/${deviceId}`);
    get().fetch();
  },

  // Super admin: hard-delete a single device everywhere
  hardDelete: async (deviceId) => {
    await api.delete(`/devices/${deviceId}/everywhere`);
    get().fetch();
  },

  // Super admin: restore a soft-deleted device back to the owning admin's dashboard
  restoreDevice: async (deviceId) => {
    await api.post(`/devices/${deviceId}/restore`);
    get().fetch();
  },

  // Super admin: transfer device to another admin
  transferDevice: async (deviceId, targetAgentToken) => {
    const { data } = await api.post(`/devices/${deviceId}/transfer`, { target_agent_token: targetAgentToken });
    get().fetch();
    return data;
  },
}));
